import { RANK_TIERS, SEASONS } from "./data/DiscordPageData";

const band = ({ floor, ceiling }) =>
  ceiling === null
    ? `${floor.toLocaleString()}+`
    : `${floor.toLocaleString()} – ${ceiling.toLocaleString()}`;

export default function DiscordRanks() {
  return (
    <>
      {/* ── RANKS ────────────────────────────────────────────────── */}
      <section className="dsc-section" id="ranks">
        <div className="dsc-eyebrow">Rank Ladder</div>
        <h2 className="dsc-h2">
          Fifteen tiers. <span className="hi">One summit.</span>
        </h2>
        <p className="dsc-section-sub dsc-wide">
          Climb from Novice to Divine on your quantum points. From{" "}
          <strong>Knight</strong> upward every tier is split into three
          500-point divisions, climbed III → II → I. Your rank shows on your
          profile, the leaderboard and your contribution heatmap.
        </p>

        <div className="dsc-ranks">
          {RANK_TIERS.map((t) => (
            <div
              key={t.name}
              className="dsc-rank"
              style={{ "--rank-accent": t.accent }}
            >
              <span className="dsc-rank-tier">Tier {t.level}</span>
              <img
                src={t.image}
                alt={`${t.name} rank emblem`}
                className="dsc-rank-img"
                loading="lazy"
              />
              <strong className="dsc-rank-name">{t.name}</strong>
              <span className="dsc-rank-band">{band(t)} pts</span>
              {t.divided && <span className="dsc-rank-div">III · II · I</span>}
            </div>
          ))}
        </div>

        <div className="dsc-season">
          <div className="dsc-season-copy">
            <div className="dsc-season-head">Seasons</div>
            <p>
              From Knight up, ranks run in seasons of three months on Pakistan
              time. When a season starts, every Knight and above goes back to{" "}
              <strong>Knight III</strong>: season points begin at{" "}
              <strong>3,000</strong>, not zero, and everything earned in the
              season is added on top. Below Knight nothing resets, and your
              profile always keeps the <strong>highest rank</strong> you have
              reached.
            </p>
          </div>
          <div className="dsc-season-grid">
            {SEASONS.map((s) => (
              <div key={s.key} className="dsc-season-card">
                <span className="dsc-season-q">{s.key}</span>
                <span className="dsc-season-m">{s.months}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
